import { Box, Modal } from '@mui/material';
import { DestinationChildrenModel } from '../../data/destination.model.child';
import { DestinationModalNames } from '../../data/destination.modal.name.tsx';

interface Props {
  activeModal: DestinationChildrenModel | null;
  onClose: () => void;
  createContent: React.ReactNode;
  updateContent: React.ReactNode;
}

const DestinationModalView = ({ activeModal, onClose, createContent, updateContent }: Props) => {
  const content =
    activeModal?.name === DestinationModalNames.CREATE
      ? createContent
      : activeModal?.name === DestinationModalNames.UPDATE
        ? updateContent
        : null;

  return (
    <Modal
      open={activeModal != null}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          width: '100%',
          maxWidth: '900px',
          borderRadius: '12px',
          maxHeight: { xs: '90vh', md: '800px' },
          overflow: 'hidden',
        }}
      >
        {content}
      </Box>
    </Modal>
  );
};

export default DestinationModalView;
